const getters = {
  // token: state => state.user.token,
  // token: state => state.user.token,
  user: state => state.user.userInfo,
}
export default getters
